/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetCategories200ResponseInner
 */
export interface GetCategories200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetCategories200ResponseInner
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetCategories200ResponseInner
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof GetCategories200ResponseInner
     */
    catalogId: string;
    /**
     * 
     * @type {string}
     * @memberof GetCategories200ResponseInner
     */
    catalogName: string;
}

/**
 * Check if a given object implements the GetCategories200ResponseInner interface.
 */
export function instanceOfGetCategories200ResponseInner(value: object): value is GetCategories200ResponseInner {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('catalogId' in value) || value['catalogId'] === undefined) return false;
    if (!('catalogName' in value) || value['catalogName'] === undefined) return false;
    return true;
}

export function GetCategories200ResponseInnerFromJSON(json: any): GetCategories200ResponseInner {
    return GetCategories200ResponseInnerFromJSONTyped(json, false);
}

export function GetCategories200ResponseInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCategories200ResponseInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'catalogId': json['catalogId'],
        'catalogName': json['catalogName'],
    };
}

export function GetCategories200ResponseInnerToJSON(json: any): GetCategories200ResponseInner {
    return GetCategories200ResponseInnerToJSONTyped(json, false);
}

export function GetCategories200ResponseInnerToJSONTyped(value?: GetCategories200ResponseInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'catalogId': value['catalogId'],
        'catalogName': value['catalogName'],
    };
}

